// import { SearchBar, Button, WhiteSpace, WingBlank } from "antd-mobile";
import React from "react";
import { Header } from "./Introduce";
import styles from "../css/News.css";
import { request } from "../request";


class TestKnow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 1,
      data: [],
    };
  }

  componentDidMount() {
    request("wechat/news", {}, ({ data }) => {

      if (data.code === 1) {
        this.setState({ data: data.data })
      }
      console.log(this.data)
    })
  }

  onClick(e, val) {
    window.location.href = val.url
  }


  render() {
    return (
      <div>
        <Header text="新闻资讯"></Header>
        <div className={styles.main}>
          {this.state.data.length > 0 && this.state.data.map((val, index) => (
            <div className={styles.item} onClick={e => {
              this.onClick(e, val)
            }} key={index}>
              <div
                style={{
                  height: "72px",
                  border: "1px solid #c1c1c1",
                  borderRadius: "6px",
                  display: "flex",
                }}
              >
                <img
                  src={val.thumb_url}
                  // src="http://mmbiz.qpic.cn/mmbiz_jpg/UZIZqBdg4Pk11NVA5pggqkic5VxA6Z9ccnzQg7kXr4eanrqLuyRlsicNnicv6liaQrPfGaMR1ibHeicEWP6rnU5UF0bA/0"
                  alt=""
                  className={styles.img}
                ></img>
              </div>

              <div style={{ width: "50%" }}>
                <div className={styles.right}>
                  <span className={styles.title}> {val.title}</span>

                  <div className={styles.bottom}>
                    <img
                      src={require("../static/时间.png")}
                      alt=""
                      className={styles.dataImg}
                    ></img>
                    <span className={styles.dataText}>{val.create_time}</span>
                  </div>
                </div>
                {/* <div className={styles.content}>
              <p className={styles.text}>{val.digest}</p>
            </div> */}
              </div>

            </div>
          ))}

          {this.state.data.length == 0 && (
            <span
              style={{
                fontSize: "2rem",
                display: "flex",
                justifyContent: "center",
                marginTop: "5rem",
              }}
            >
              敬请期待
            </span>
          )

          }
        </div>
      </div>

    )
  }
}

export default TestKnow;



// WEBPACK FOOTER //
// ./src/pages/News.js